import { ApiResponse } from './ApiResponse';

export class BlobApiResponse extends ApiResponse<Blob> {
  downloadBlob(filename: string): void {
    const blob = this.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  }

  getBlobAsString(): string {
    const blob = this.data;
    return window.URL.createObjectURL(blob);
  }
}
